import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { maybeInitSentry } from "../observability/sentry";
import { MarketingApp } from "./MarketingApp";
import "../styles.css";

// Only fires if the user has previously accepted optional cookies. The
// CookieConsent banner inside <MarketingApp /> handles the prompt and
// calls initSentry() directly on accept.
maybeInitSentry();

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <BrowserRouter>
          <MarketingApp />
        </BrowserRouter>
      </HelmetProvider>
    </QueryClientProvider>
  </StrictMode>,
);
